import React from "react"
import styled from "styled-components"
import {
	AuthorFlex,
	AuthorLeft,
	AuthorImage,
	AuthorName,
	AuthorText,
	AuthorFlexMobile,
	AuthorLeftMobile,
	AuthorRightMobile,
	AuthorRight,
} from "./PostFooter.styles"
import { PrismicRichText } from "@prismicio/react"

export const AuthorSection = ({ data }) => {
	const authorImage = data.results[0].data.author_image?.url
	const authorName = data.results[0].data.author_name[0]?.text
	const authorText = data.results[0].data.author_text[0]?.text
	const showAuthor = data.results[0].data.show_author_block

	if (showAuthor) {
		return (
			<>
				<AuthorFlex>
					<AuthorLeft>
						<AuthorImage src={authorImage}></AuthorImage>
					</AuthorLeft>
					<AuthorRight>
						<AuthorName>{authorName}</AuthorName>
						<AuthorText>
							<PrismicRichText field={data.results[0].data.author_text} />
						</AuthorText>
					</AuthorRight>
				</AuthorFlex>
				<AuthorFlexMobile>
					<AuthorLeftMobile>
						<AuthorImage src={authorImage}></AuthorImage>
						<AuthorName>{authorName}</AuthorName>
					</AuthorLeftMobile>
					<AuthorRightMobile>
						<AuthorText>
							<PrismicRichText field={data.results[0].data.author_text} />
						</AuthorText>
					</AuthorRightMobile>
				</AuthorFlexMobile>
			</>
		)
	}
	return <></>
}
